import { render, staticRenderFns } from "./LapidusStudents.vue?vue&type=template&id=4f58b731&"
import script from "./LapidusStudents.vue?vue&type=script&lang=js&"
export * from "./LapidusStudents.vue?vue&type=script&lang=js&"
import style0 from "./LapidusStudents.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports